type GetFormModelFn = () => { Validierungscode: string;[key: string]: any };
type SetFormModelFn = (model: any) => void;
type ToggleSubmitButtonFn = (disabled: boolean) => void;

export class CaptchaService {
	private readonly getFormModel: GetFormModelFn;
	private readonly setFormModel: SetFormModelFn;
	private readonly toggleSubmitButton: ToggleSubmitButtonFn;

	constructor(
		getFormModel: GetFormModelFn,
		setFormModel: SetFormModelFn,
		toggleSubmitButton: ToggleSubmitButtonFn
	) {
		this.getFormModel = getFormModel;
		this.setFormModel = setFormModel;
		this.toggleSubmitButton = toggleSubmitButton;
	}

	public registerCaptchaHandler($form: JQuery): void {
		$form.on('captcha-completed', this.captchaHandler.bind(this));
	}

	private captchaHandler(ev: Event): void {
		const customEvent = ev as CustomEvent<{ solution: string }>;
		const formModel = this.getFormModel();

		formModel.Validierungscode = customEvent.detail.solution;
		this.setFormModel(formModel);
		this.toggleSubmitButton(false);
	}

	public isCaptchaValid(): boolean {
		const value = $('[name="frc-captcha-response"]').val() as string;
		return value.trim() !== "" && value.trim() !== '.ACTIVATED';
	}

	public resetAllCaptchas(): void {
		document.querySelectorAll('friendly-captcha').forEach(el =>
			el.dispatchEvent(new CustomEvent('captcha-reset'))
		);
	}
}
